import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";

const favicon = require("./img/favicon-192x192.png");

ReactDOM.render(React.createElement(App), document.querySelector("#app"));

const faviconLink = document.createElement("link");
faviconLink.setAttribute("rel", "icon");
faviconLink.setAttribute("type", "image/png");
faviconLink.setAttribute("sizes", "192x192");
faviconLink.setAttribute("href", favicon);
document.querySelector("head")?.appendChild(faviconLink);
